export default "__VITE_ASSET__yE7feEq9__"